import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: 'var(--color-black)',
      color: 'var(--color-white)',
      padding: 'var(--spacing-xl) 0 var(--spacing-lg)',
      marginTop: 'auto'
    }}>
      <div className="container" style={{ padding: '0 var(--spacing-md)' }}>
        <div style={{ display: 'flex', gap: 'var(--spacing-xl)', flexWrap: 'wrap', marginBottom: 'var(--spacing-lg)' }}>
          {/* Company */}
          <div style={{ flex: '1', minWidth: '200px' }}>
            <div style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-base)', marginBottom: 'var(--spacing-xs)', color: '#FFFFFF' }}>
              Neuberlinr Private Limited
            </div>
            <div style={{ fontSize: 'var(--font-size-sm)', color: '#9CA3AF', lineHeight: '1.6' }}>
              CIN: U70200TN2026PTC188018<br />
              GSTIN: 33AALCN1785B1ZL
            </div>
          </div>

          {/* Head Office */}
          <div style={{ flex: '1', minWidth: '180px' }}>
            <div style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--spacing-xs)', color: '#D1D5DB' }}>
              Head Office
            </div>
            <div style={{ fontSize: 'var(--font-size-sm)', color: '#9CA3AF', lineHeight: '1.6' }}>
              No.47, Bharathi Street,<br />
              Tiruchirappalli - 620005,<br />
              Tamil Nadu
            </div>
          </div>

          {/* Madurai Office */}
          <div style={{ flex: '1', minWidth: '180px' }}>
            <div style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--spacing-xs)', color: '#D1D5DB' }}>
              Madurai Office
            </div>
            <div style={{ fontSize: 'var(--font-size-sm)', color: '#9CA3AF', lineHeight: '1.6' }}>
              No.166A, Vakkil New St, Simmakkal,<br />
              Madurai - 625001,<br />
              Tamil Nadu
            </div>
          </div>

          {/* Opening Hours */}
          <div style={{ flex: '1', minWidth: '180px' }}>
            <div style={{ fontWeight: 'var(--font-weight-semibold)', fontSize: 'var(--font-size-sm)', marginBottom: 'var(--spacing-xs)', color: '#D1D5DB' }}>
              Opening Hours
            </div>
            <div style={{ fontSize: 'var(--font-size-sm)', color: '#9CA3AF', lineHeight: '1.6' }}>
              Monday to Sunday<br />
              9:00 AM – 8:00 PM IST
            </div>
          </div>
        </div>

        <div style={{ borderTop: '1px solid #374151', paddingTop: 'var(--spacing-md)', textAlign: 'center', color: '#6B7280', fontSize: 'var(--font-size-sm)' }}>
          &copy; {new Date().getFullYear()} Neuberlinr Private Limited. All rights reserved.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
